











import Vue from 'vue'

export default Vue.extend({
  computed: {
    notifications(): {[key: string]: string}[] {
      return this.$store.state.notifications
    }
  },
  methods: {
    formatDate(value: string) {
      const date = new Date(value.replace(/-/g, '/'))
      const formatOptions = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'}
      return date.toLocaleDateString('ja-JP', formatOptions)
    }
  }
})
